import styled from 'styled-components';
import { ReactComponent as RawDropdownActiveSVG } from '../../../../assets/icons/dropdown_active.svg';

export const IconDropdownActive = styled(RawDropdownActiveSVG)``;
